const AuthRoutes = {
  path: '/auth',
  component: () => import('@/layouts/BlankLayout.vue'),
  meta: {
    guest: true
  },
  children: [
    {
      name: 'Login',
      path: '/auth/login',
      component: () => import('@/pages/guest/LoginPage/LoginPage.vue')
    },
    {
      name: 'Register',
      path: '/auth/register',
      component: () => import('@/pages/guest/RegisterPage/RegisterPage.vue')
    },
    {
      name: 'ForgotPassword',
      path: '/auth/forgot-password',
      component: () => import('@/pages/guest/ForgotPasswordPage/ForgotPasswordPage.vue')
    },
    {
      name: 'ConfirmEmail',
      path: '/auth/confirm-email',
      component: () => import('@/pages/guest/ConfirmEmailPage/ConfirmEmailPage.vue')
    }
  ]
};

export default AuthRoutes;
